import React, { useEffect, useRef } from 'react';

// Loading the vendor bundle sets window.PayButton as a side effect; the module's
// own require()/module.exports value isn't reliable under webpack's ESM interop.
require('../vendor/paybutton');
const paybutton = window.PayButton;

const PayButton = ({
  to,
  amount,
  currency,
  size,
  text,
  hoverText,
  successText,
  altpayment,
  disableAltpayment,
  onSuccess,
}) => {
  const buttonRef = useRef(null);

  useEffect(() => {
    if (!buttonRef.current) {
      return undefined;
    }

    paybutton.render(buttonRef.current, {
      to,
      amount,
      currency,
      size,
      text,
      hoverText,
      successText,
      altpayment,
      disableAltpayment,
      onSuccess,
    });

    return () => {
      if (buttonRef.current) {
        buttonRef.current.innerHTML = '';
      }
    };
  }, [
    to,
    amount,
    currency,
    size,
    text,
    hoverText,
    successText,
    altpayment,
    disableAltpayment,
    onSuccess,
  ]);

  return <div ref={buttonRef} />;
};

export default PayButton;